import { t } from 'helpers'
import s from './index.module.scss'
import Image from 'assets/images/landing-unlock.png'
import Button from 'components/UI/Button'
import { useNavigate } from 'react-router-dom'
import { PATHS } from 'types/enums'

const Unlock = (): JSX.Element => {
	const navigate = useNavigate()

	return (
		<section className={s.container}>
			<img src={Image} alt="image-background" />
			<div className={s.wrapper}>
				<h2>{t('APP_LANDING_UNLOCK_TITLE')}</h2>
				<span style={{ color: 'var(--mono200)' }}>
					{t('APP_LANDING_UNLOCK_DESCRIPTION')}
				</span>
				<Button
					onClick={() => {
						navigate(`/${PATHS.JOIN}/${PATHS.REGISTER}`)
					}}
					variant="outlined"
					style={{
						gap: '10px',
						color: 'var(--mono900)',
						borderColor: 'var(--theme-primary)',
						backgroundColor: 'var(--theme-primary)',
					}}>
					{t('APP_LANDING_UNLOCK_BUTTON')}
				</Button>
			</div>
		</section>
	)
}

export default Unlock
